<template>
  <section class="guided-mode-sequential-group guided-mode-attribute-step">
    <div class="guided-mode-sequential-group__questions">
      <div
        v-for="row in rows"
        :key="row.conceptId"
        :data-concept-id="row.conceptId"
        class="guided-mode-sequential-group__question"
      >
        <guided-mode-question
          :prompt="row.prompt"
          :options="row.options"
          :collection="collection"
          :selected-values="row.selectedValues"
          :input-id="`guided-attribute-${row.conceptId.replace(/[^a-z0-9]+/gi, '-')}`"
          @option-selected="value => $emit('select', { conceptId: row.conceptId, value })"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import GuidedModeQuestion from './GuidedModeQuestion.vue'
import type { GuidedAttributeRow } from '../composables/useGuidedAttributeStep'

export default defineComponent({
  name: 'GuidedModeAttributeStep',
  components: { GuidedModeQuestion },
  props: {
    rows: { type: Array as PropType<GuidedAttributeRow[]>, default: () => [] },
  },
  emits: ['select'],
  data: () => ({
    collection: { type: 'option', selection: 'single', defaultWidget: 'single_select' },
  }),
})
</script>
